<template>
  <div @click="hideSearchPanel">
     <div class="top-contrainer">
        <div class="main-header">
            <div class="left-header" v-if="version != 'guangdianzhongda'">
              <div class="layout-header-system">
                <router-link to="/main/search" v-if="$route.path ==='/law/home'">
                  <div class="layout-header-system-back-btn">
                    <i class="el-icon-arrow-left"></i>
                    <span>首页</span>
                  </div>
                </router-link>
                <div class="layout-header-system-back-btn pagejump" v-else @click="goback">
                  <i class="el-icon-arrow-left"></i>
                  <span>返回</span>
                </div>
                <img v-if="projectInfoConfig.fullLogo" class="layout-header-system-logo" :src="projectInfoConfig.fullLogo" @click="goStaticHome">
                <span class="layout-header-system-label">智能法规检索</span>
                <span class="layout-header-system-enterprise" v-if="$store.getters.isEnterprise">企业版</span>
              </div>
            </div>
            <div class="left-header" v-else>
              <div class="layout-header-system">
                <div class="layout-header-system-back-btn pagejump" v-if="$route.path !=='/law/home'" @click="goback">
                  <i class="el-icon-arrow-left"></i>
                  <span>返回</span>
                </div>
                <img v-if="projectInfoConfig.fullLogo" class="layout-header-system-logo" :src="projectInfoConfig.fullLogo" @click="goStaticHome">
                <span class="layout-header-system-label">智能法规检索</span>
              </div>
            </div>
            <div class="law-search" v-if="false">
                <div class="search-line">
                <input type="text" v-model="searchKey"  @keydown="keySearch($event)" @focus="inputFocus"  placeholder="输入关键词或多关键词搜索，中间空格隔开">
                </div>
                <button class="search-button" @click="searchEvent"><span class="search-icon"><img src="../../assets/search.png" alt=""></span></button>
                <div class="search-preview" v-if="previewList.length>0" id="popBox">
                    <div class="preview-item word-middle" v-for="(item,index) in previewList" :key="index" @click="goPreview(item)"> 
                      <span v-html="highlight(item.title,searchKey)"></span>
                    </div>
                </div>
            </div>
            <template v-if="$route.name !== 'lawCenter'">  
              <div class="search-high-box">
                <div class="search-high-box-indiv pagejump-checkbox" @click="searchBtn('', 'normal')" v-if="$route.name !== 'lawClause'">
                  <span>新检索</span>
                </div>
                <div class="search-high-box-indiv"  @click="highSearchClick(true, 'high')">
                  <img src="../../assets/search-select.png" :style="{ height: '18px' }" />
                  <span>高级检索</span>
                </div>
              </div>
              <div class="search-body-box">
                <div class="search-select">
                    <el-select v-model="searchSelector" placeholder="请选择">
                        <el-option
                            v-for="item in searchSelectOption"
                            :key="item"
                            :label="item"
                            :value="item">
                        </el-option>
                    </el-select>
                </div>
                
                <div class="search-input">
                    <input
                        v-model="searchKey"
                        style="margin-left:5px;"
                        @keydown="keySearch($event)"
                        @focus="keySearchFocus"
                        @blur="keySearchBlur"
                        ref="lawSearchInput"
                        clearable
                        placeholder="←左侧选择区段，输入关键词，搜索更精准"
                    />
                    <i class="el-icon-circle-close search-input-close" @click="searchKey = ''" v-show="searchKey.length"></i>
                    
                    <div class="search-preview" v-show="previewListFlag && previewList.length > 0">
                        <div class="preview-item word-middle" v-for="(item,index) in previewList" :key="index" @click="searchBtn(item)"> 
                        <span v-html="highlight(item.title,searchKey)"></span>
                        </div>
                    </div>

                    <div class="search-history" v-show="!searchKey && searchHistoryFlag && previewList.length <= 0">
                      <div class="search-history-wrap">
                        <div class="search-history-item"
                            v-for="(item,index) in searchHistoryList"
                            :key="index"
                            @click="searchHistoryItemClick(index)">{{item}}</div>
                      </div>
                      <div class="search-history-del">
                        <span class="search-history-del-fr" @click="clearSearchHistory">
                          <i class="el-icon-delete"></i> <span>清除历史</span>
                        </span>
                      </div>
                    </div>
                </div>
                <div class="search-btn" @click="searchBtn('', 'normal')" v-if="$route.name === 'lawClause'">
                  <span>新检索</span>
                </div>
                <div class="search-btn" @click="searchBtn('', 'result')" v-else>
                  <span>结果中检索</span>
                </div>
              </div>
            </template>
            <div class="right-header" v-if="version != 'guangdianzhongda'">
              <el-dropdown trigger="click" v-if="isThird || userInfo.tel">
                <span class="el-dropdown-link">
                  <span class="icon-middle" style="width:30px;margin-right: 10px;">
                    <img :src="projectInfoConfig.isDefault ? defaultAvatar1 : defaultAvatar2" alt="">
                  </span>
                  <template v-if="userInfo.tel">{{userInfo.tel | phone-filter}}<i class="el-icon-arrow-down el-icon--right"></i></template>
                </span>
                <el-dropdown-menu slot="dropdown" v-if="!isThird">
                  <el-dropdown-item>
                    <div class="header-portrait">
                      <div class="icon-middle" style="width:30px;margin-left:-5px;margin-right: 10px;">
                        <img src="../../assets/default-icon.png" alt="">
                      </div>
                      <div>
                        <p>{{userInfo.tel | phone-filter}}</p>
                      </div>
                    </div>
                  </el-dropdown-item>

                  <el-dropdown-item>
                    <div class="user-dropdown" @click="goTarget('/law/center')">
                     <span>个人中心</span>
                    </div>
                  </el-dropdown-item>
                   <el-dropdown-item v-if="!projectInfoConfig.hideLogout">
                    <div class="user-dropdown" @click="loginOut">
                     <span>退出</span>
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <div v-else>
                <a @click="showLogin = true">登录</a>
                <el-button @click="showRegister = true" type="primary">注册</el-button>
              </div>  
            </div>
            <div class="right-header" v-else>
              <span class="el-dropdown-link" v-if="userInfo.id">
                <span class="icon-middle" style="width:30px;margin-right: 10px;">
                    <img src="../../assets/default-icon.png" alt="">
                  </span>
              </span>
              <div v-else>
                <a @click="loginGdStatus = true">登录</a>
              </div>  
            </div>
        </div>
        <div class="course-filter" v-show="highSearchFlag">
          <div class="course-filter-head">
            <span class="course-filter-head-fr" @click="highSearchClick(false)"><i class="el-icon-close"></i></span>
            <span class="course-filter-head-name">高级检索</span>
          </div>
          <lawfilter ref="lawfilter" @lawfilterEmit="lawfilterEmit" />
        </div>
     </div>
     <home @removeFilter="removeFilter" v-on:changeStatus="changeStatus" ref="lawHome" v-if="searchHome"></home>
     <container v-else  @removeFilter="removeFilter"></container>

      <!-- 广电仲达登录 -->
    <el-dialog width="360px" custom-class="memberDialog local-login" :show-close="loginGdClose" :visible.sync="loginGdStatus" title="手机号免密登录" @close="closeLocalLogin" :close-on-click-modal="false">
       <div>
          <div class="form">
              <el-input v-model="model.tel" type="text" placeholder="手机号"></el-input>
          </div>
          <div class="form">
              <el-input v-model="model.verificode" type="text" placeholder="验证码"></el-input>
              <a class="send-number" @click="sendCode" :disabled="disabled">{{sendWord}}</a>
          </div>
          
          <div style="margin:40px 0 80px;">
              <div>
                <el-button style="width:100%;background:@mainColor" @click="verifiEvent" type="primary">立即登录</el-button> 
              </div>
          </div>
          <div class="form">
              <span>登录即代表同意<span style="color:#4A90E2;cursor:pointer" @click="agreement=true">《用户注册协议》</span>和<span style="color:#4A90E2;cursor:pointer" @click="privacy=true">《隐私政策》</span></span>
          </div>
       </div>
    </el-dialog>

     <el-dialog width="700px" custom-class="buyVipDialog" :visible.sync="buyVip && productList.length>0" :show-close="true" :close-on-click-modal="true" @close="closeDialog">
       <div class="buy-panel">
          <div class="buy-panel-top">
            <div class="header-portrait">
              <div style="margin: 0 10px 10px 10px">
                <span style="width:32px;" class="icon-big"><img src="../../assets/default-icon-64.png" alt=""></span>
              </div>
              <div class="tel">
                <p>{{userInfo.tel}}</p>
              </div>
            </div>
          </div>
          <div class="buy-panel-body">
            <div class="buy-panel-left">
              <ul>
                <li @click="choicePro(item)" :class="activeBuy==item.name?'cur':''" v-for="(item,index) in productList" :key="index">
                  <span class="vip-list-icon">
                    <img src="../../assets/vip-list.png" alt="">
                    <img src="../../assets/vip-list-gray.png" alt="">
                  </span>
                  <a>{{item.name}}</a>
                </li>
              </ul>
            </div>
            <div class="buy-panel-right">
              <h4>{{productModel.name}}VIP套餐</h4>
              <div style="display:flex">
                <div v-for="(col,idx) in productModel.subItem" :key="idx" class="sub-pro" @click="choiceWay(col,idx)" :class="activeWay == idx?'cur':''">
                  <p v-if="col.productList[0].chargeType == 'month'">{{col.productList[0].chargeCycle}}个月</p>
                  <p v-else>{{col.productList[0].chargeCycle}}次</p>
                  <span>¥{{col.discountPrince}}</span>
                  <s>原价{{col.firstPrince}}</s>
                </div>
              </div>

              <div class="vip-tip">
                <div v-if="productModel.descHtml" v-html="productModel.descHtml"></div>
                <template v-else>
                  <p>VIP特权</p>
                  <span class="word-normal">{{productModel.desc}}</span>
                </template>
              </div>

              <div class="pay-panel">
                <div id="qrcode" ref="qrcode"></div>
                <div style="margin-left:20px;">
                  <div style="color:#222;font-size:16px;margin-bottom:10px;">应付金额</div>
                    <div>
                      <span style="color:#E42626;font-size:28px;font-weight:bold">
                        ¥{{way.discountPrince}}
                      </span>
                      <s style="color:#999;" class="word-normal" v-if="way.firstPrince">
                        原价{{way.firstPrince}}元
                      </s>
                    </div>
                    <div style="margin-top:27px;">
                      <span class="wechat-pay"><img src="../../assets/wechat-pay.png" alt=""></span>
                      <span>使用微信扫码支付</span>
                    </div>
                </div>
              </div>
            </div>
          </div>
       </div>
     </el-dialog>

     <div class="back-to-top" @click="backTop" v-if="!$route.query.export_token">
       <span><i class="el-icon-top"></i></span>
       <p class="word-small">返回顶部</p>
     </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import Home from "@/views/law/home";
import container from "@/views/law/container";
import { sliceStr, highlight } from "../../filter";
import { mapGetters } from "vuex";
import base64 from "js-base64";

import lawfilter from './lawfilter';
import searchMixin from './js/search-mixin.js'
import { services } from '@/service';
import { projectInfoConfig } from '@/constant';
import defaultAvatar1 from '@/assets/default-icon.png';
import defaultAvatar2 from '@/assets/default-avatar.png';

export default {
  mixins: [searchMixin],
  data() {
    return {
      projectInfoConfig,
      defaultAvatar1,
      defaultAvatar2,
      version: window.version,
      model: {
        tel: "",
        password: "",
        name: "",
        verificode: ""
      },
      disabled: false,
      sendWord: "发送验证码",
      userInfo:{},
      resPanelShow: false,
      isLoad: false,
      searchKey: "",
      searchHome: true,
      userInfo: {},
      searchType: "综合",
      productList: [],
      activeBuy: "",
      productModel: {},
      activeWay: "",
      way: {},
      orderId: "",
      payTimeOut: "",
      previewList: [],
      resultCheckedFlag: false,
      queryObj: {},
      loginGdStatus: false,
      loginGdClose: true
    };
  },
  computed: {
    ...mapGetters(["perssion", "freeTime", "buyVip", 'isThird']),
  },

  components: { Home, container, lawfilter },
  created() {
    this.getUserInfo();
  },
  mounted() {
    // this.searchKey = this.$route.query.param
    this.searchType = this.$route.query.searchType || this.$route.query.toName || "综合";
    this.userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
    if (this.$route.name == "lawHome") {
      this.searchHome = true;
    } else {
      this.searchHome = false;
    }
    if (this.userInfo.tel) {
      this.httpGet("user/products?purpose=PC").then((data) => {
        if (data && data.statusCode == 1) {
          // this.productList = data.data;
          data.data.forEach((v) => {
            var find = _.find(this.productList, { name: v.name });
            if (!find) {
              v.subItem = [];
              v.subItem.push({
                id: v.id,
                name: v.name,
                desc: v.desc,
                descHtml: v.descHtml,
                chargeCycle: v.chargeCycle,
                chargeType: v.chargeType,
                payPrince: v.payPrince,
                discountPrince: v.discountPrince,
                productList: v.productList,
                firstPrince: v.firstPrince,
                userType: v.userType,
              });
              this.productList.push(v);
            } else {
              find.subItem.push({
                id: v.id,
                name: v.name,
                desc: v.desc,
                descHtml: v.descHtml,
                chargeCycle: v.chargeCycle,
                chargeType: v.chargeType,
                payPrince: v.payPrince,
                discountPrince: v.discountPrince,
                productList: v.productList,
                firstPrince: v.firstPrince,
                userType: v.userType,
              });
            }
          });
          if (data.data.length > 0) {
            this.activeBuy = data.data[0].name;
            this.productModel = data.data[0];
          }
        }
      });
    }

    if (this.$route.path !='/law/home' && !this.userInfo.tel && window.version == 'guangdianzhongda') {
      this.loginGdStatus = true;
      this.loginGdClose = false;
    }

  },
  watch: {
    buyVip: function(val) {
      if (!val && this.payTimeOut) {
        clearInterval(this.payTimeOut);
      }
      if (val) {
        this.choiceWay(this.productModel.subItem[0], 0);
      }
    },
    searchKey: function(val) {
      if (val) {
        this.getPreview();
      } else {
        this.previewList = [];
      }
    },
  },

  methods: {
    closeLocalLogin() {
      this.$store.commit("setLocalLogin", false);
    },
    getUserInfo() {
      this.httpGet(`admin/user`).then((res) => {
        if (res && res.statusCode == 1) {
          localStorage.setItem("userInfo", JSON.stringify(res.data));
          sessionStorage.setItem("_USER_INFO_", JSON.stringify(res.data));
          this.userInfo = res.data;
          
          console.log(this.loginGdStatus, this.userInfo.tel, window.version);
          if (this.loginGdStatus && this.userInfo.tel && window.version == 'guangdianzhongda') {
            window.location.reload();
          }
          
        } else {
          this.$message({
            message: res.message,
            type: "warning",
          });
        }
      });
    },
    verifiEvent() {
      if (!this.model.tel) {
        this.$message({
          message: "请输入手机号",
          type: "warning",
        });
        return;
      }
      if (!this.model.verificode) {
        this.$message({
          message: "请输入验证码",
          type: "warning",
        });
        return;
      }
      if (this.model.verificode.length > 6) {
        this.$message({
          message: "请输入正确的验证码",
          type: "warning",
        });
        return;
      }
      this.httpPost("user/valid", {
        tel: this.model.tel,
        code: this.model.verificode,
      }).then((data) => {
        if (data && data.statusCode == 1) {
          if (data.data.token) {
            window.localStorage.setItem("token", data.data.token);
            sessionStorage.setItem("_TOKEN_", data.data.token);
            
            this.getUserInfo();
          } else {
            this.$message({
              message: data.data.msg,
              type: "warning",
            });
          }
        } else {
          this.$message({
            message: data.message,
            type: "warning",
          });
        }
      });
    },
    sendCode() {
      if (!this.model.tel) {
        this.$message({
          message: "请输入手机号",
          type: "warning",
        });
        return;
      }
      if (this.sendWord !== "重新发送" && this.sendWord !== "发送验证码") {
        return;
      }

      var time = 60;
      var timer = setInterval(() => {
        time--;
        this.sendWord = `${time}s`;
        if (time == 0) {
          clearInterval(timer);
          this.sendWord = "重新发送";
          this.disabled = false;
        }
      }, 1000);

      this.disabled = true;

      this.httpPost("user/sms/send", { tel: this.model.tel }).then((data) => {
        if (data && data.statusCode == 1) {
          this.$message({
            message: "发送成功",
            type: "success",
          });
        } else {
          this.$message({
            message: data.message,
            type: "warning",
          });
        }
      });
    },
    sliceStr: sliceStr,
    highlight: highlight,
    changeStatus() {
      this.searchHome = false;
    },
    removeFilter() {
      // this.$refs.lawfilter.initFilterGroup();
    },
    inputFocus() {
      if (this.searchKey) {
        // this.resPanelShow = true;
      }
    },
    qrcode(name, id, discountPrince) {
      this.httpPost("wechat/order", {
        productId: id,
        price: discountPrince,
        body: "小包公-" + name,
      }).then((data) => {
        if (data && data.statusCode == 1) {
          let qrcode = new QRCode("qrcode", {
            width: 130, // 二维码宽度，单位像素
            height: 130, // 二维码高度，单位像素
            text: data.data.codeUrl, // 生成二维码的链接
          });
          this.orderId = data.data.orderId;
          clearInterval(this.payTimeOut);
          this.payTimeOut = setInterval(() => {
            this.getOrderStatus();
          }, 2000);
        } else {
          this.$message({
            message: data.message,
            type: "warning",
          });
        }
      });
    },
    closeDialog() {
      this.$store.commit("setBuyVip", false);
    },
    getPreview() {
      this.httpPost(`/law/preview`, {
        title: this.searchKey
      }).then((data) => {
        if (data && data.statusCode == 1) {
          this.previewList = data.data;
        }
      });
    },
    lawfilterEmit(obj) {
      this.searchKey = '';
      this.queryObj = obj;
      this.goPreview('', obj);
    },
    goPreview(item, queryObj = {}) {
      if (item) {
        this.$router.push({
          path: "/law/midpage",
          query: {
            param: item.title,
          },
        });
      } else {
        this.$router.push({
          path: "/law/midpage",
          query: queryObj
        })
      }
      this.previewList = [];
      this.highSearchFlag = false;
      this.searchKey = '';
    },
    backTop() {
      this.Bus.$emit('backTop');
      document.querySelector('html').scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    goQuestionnaireCenter() {
      location.href = `${location.origin}/fanwen/questionnaire/center`;
    },
    goTarget(path) {
      this.$router.push({
        path: path,
      });
    },
    openBuyVip() {
      if (this.productModel.subItem && this.productModel.subItem.length > 0) {
        //  this.choiceWay(this.productModel.subItem[0],0);
        this.$store.commit("setBuyVip", true);
      } else {
        this.$message({
          message: "获取产品失败，请稍后再试",
          type: "warning",
        });
      }
    },
    qrcode(name, id, discountPrince) {
      this.httpPost("wechat/order", {
        productId: id,
        price: discountPrince,
        body: "小包公-" + name,
      }).then((data) => {
        if (data && data.statusCode == 1) {
          let qrcode = new QRCode("qrcode", {
            width: 130, // 二维码宽度，单位像素
            height: 130, // 二维码高度，单位像素
            text: data.data.codeUrl, // 生成二维码的链接
          });
          this.orderId = data.data.orderId;
          clearInterval(this.payTimeOut)
          this.payTimeOut = setInterval(() => {
            this.getOrderStatus();
          }, 2000);
        } else {
          this.$message({
            message: data.message,
            type: "warning",
          });
        }
      });
    },
    getOrderStatus() {
      this.httpGet(`wechat/order/${this.orderId}`).then((data) => {
        if (data && data.statusCode == 1) {
          if (data.data.status == "SUCCESS") {
            clearInterval(this.payTimeOut);
            this.$message({
              message: "支付成功",
              type: "success",
            });
            this.$store.commit("setBuyVip", false);
          }
        }
      });
    },
    choicePro(item) {
      this.productModel = item;
      this.activeBuy = item.name;
      this.choiceWay(this.productModel.subItem[0], 0)
    },
    choiceWay(col, index) {
      this.activeWay = index;
      this.way = col;
      this.$nextTick(() => {
        document.getElementById("qrcode").innerHTML = "";
        this.qrcode(col.name, col.id, col.discountPrince);
      });
    },
    goback() {


      // let historyList = JSON.parse(window.sessionStorage.getItem("historyList"))
      // if(this.$route.path == '/law/clause' && !this.$route.query.fromBook){
      //   this.$router.push({
      //     path: '/law/home',
      //     query:{
      //       param: this.searchKey || historyList && historyList[0].param,
      //       searchType: this.searchType
      //     }
      //   })
      // }else{
      // let searchTitle = JSON.parse(sessionStorage.getItem('lawCaseSearchTitle')) || [];
      let lawCaseFilterObj = JSON.parse(sessionStorage.getItem('lawCaseFilterObj')) || {};
      if (lawCaseFilterObj.search) {
        let searchTitleLeng = lawCaseFilterObj.search.length;
        let searchTitle = lawCaseFilterObj.search;

        if (searchTitleLeng && lawCaseFilterObj) {
          searchTitle.splice(searchTitleLeng-1, 1)
          lawCaseFilterObj.search = searchTitle

          sessionStorage.setItem('lawCaseSearchTitle', JSON.stringify(searchTitle))
          sessionStorage.setItem('lawCaseFilterObj', JSON.stringify(lawCaseFilterObj))
        }

        let pagejumpCheckbox = document.querySelector('.pagejump-checkbox');
        if (pagejumpCheckbox) {
          pagejumpCheckbox.style.display = 'flex'
        }
      }
      sessionStorage.setItem('pageJump', true)

      const curUrl = this.$route.path;
      this.$router.go(-1);
      
      setTimeout(() => {
        if (curUrl === this.$route.path) {
          this.$router.replace('/main/search');
        }
      }, 300);
      // }
    },
    hideSearchPanel() {
      var element = document.getElementById("popBox");
      if (element) {
        if (!element.contains(event.target)) {
          this.previewList = [];
        }
      }
    },
    goStaticHome() {
      if (this.isThird) {
        return;
      }
      var locationHref = window.location.href;
      location.href =
        locationHref.slice(0, locationHref.indexOf("/home.html")) +
        "/index.html";
    },
    loginOut() {
      this.httpGet("admin/logout").then((data) => {
        sessionStorage.removeItem("token");
        localStorage.removeItem("token");
        localStorage.removeItem("userInfo");
        localStorage.removeItem("timeToken");
        sessionStorage.removeItem("userInfo");
        this.userInfo = {};
        if (this.version == 'guangdianzhongda') {
          location.href = window.location.origin + "/home.html/#/main/search";
        } else {
          this.goStaticHome();
        }
        
      });
    },
    searchEvent() {
      if (this.searchKey) {
        this.previewList = [];
        this.$router.push({
          path: "/law/midpage",
          query: {
            param: this.searchKey,
          },
        });
        // if(this.$route.path == '/law/home'){
        //   this.$refs.lawHome && this.$refs.lawHome.refreshData()
        // }
        // this.$router.push({
        //   name: 'lawHome',
        //   query:{
        //     param: this.searchKey,
        //     searchType: this.searchType
        //   }
        // })
      } else {
        this.$message({
          message: "请输入关键词或多关键词搜索，中间空格隔开（如：盗窃 抢劫 ）",
          type: "error",
          duration: 1000,
        });
      }
    },
    keySearch($event) {
      this.resPanelShow = false;
      if ($event.keyCode == 13) {
        // console.log('event.keyCode')
        // this.searchEvent();
        this.searchBtn('', )
      }
    },
  },
  destroyed() {
    if (this.payTimeOut) {
      clearInterval(this.payTimeOut);
    }
  },
};
</script>
<style scoped lang="less">
.top-contrainer {
  position: sticky;
  left: 0;
  top: 0;
  z-index: 1000;

  .layout-header-system {
    display: flex;
    align-items: center;
    margin: 0 50px 0 10px;

    .layout-header-system-back-btn {
      height: 32px;
      color: #172237;
      font-size: 14px;
      line-height: 32px;
      background: #F7F7F7;
      border-radius: 0px 100px 100px 0px;
      padding: 0 11px;
      margin-left: -20px;
      margin-right: 10px;
      cursor: pointer;

      .el-icon-arrow-left {
        margin-right: 2px;
        line-height: 30px;
      }
    }

    .layout-header-system-logo {
      height: 24px;
      cursor: pointer;
      margin-right: 10px;
    }
    .layout-header-system-label {
      color: #172237;
      font-size: 16px;
      line-height: 24px;
      font-weight: bold;
    }
    .layout-header-system-enterprise {
      color: #3F6EFC;
      font-size: 14px;
      line-height: 20px;
      border: 1px solid #3F6EFC;
      border-radius: 8px 0 8px 0;
      padding: 0 10px;
      margin-left: 10px;
    }
  }
}
.head-title {
  font-size: 18px;
  color: #fff;
  line-height: 60px;
}
.form{
  margin-top: 14px;
  position:relative;
  .send-number {
    position: absolute;
    display: inline-block;
    right: 10px;
    color: #E42626;
    top: 14px;
    cursor: pointer;
  }
}

.head-title .icon {
  display: inline-block;
  padding-left: 12px;
  padding-right: 40px;
  cursor: pointer;
}

.search-bar {
  width: 490px;
  height: 34px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 13px;
  display: flex;
  background: #fff;
  border-radius: 3px;
  z-index: 99;
}

.law-search {
  width: 490px;
  height: 34px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 13px;
  display: flex;
  background: #fff;
  border-radius: 3px;
  z-index: 99;
}

// .search-preview {
//   min-height: 200px;
//   max-height: 350px;
//   overflow-y: auto;
//   width: 490px;
//   left: 50%;
//   transform: translateX(-50%);
//   top: 35px;
//   position: absolute;
//   background: rgba(255, 255, 255, 1);
//   box-shadow: 0px 6px 11px 1px rgba(0, 0, 0, 0.06);
//   border-radius: 4px;
//   border: 1px solid rgba(230, 230, 230, 1);
//   box-sizing: border-box;
//   .preview-item {
//     height: 40px;
//     line-height: 40px;
//     overflow: hidden;
//     white-space: nowrap;
//     text-overflow: ellipsis;
//     padding: 0 20px;
//   }
//   .preview-item:hover {
//     background: #f0f0f0;
//     cursor: pointer;
//   }
// }

.forecast-topHead {
  a {
    font-size: 18px;
    color: #222;
    font-weight: bold;
    cursor: pointer;
  }
  span {
    font-size: 18px;
    color: #999;
    font-weight: bold;
  }
}
.header-portrait {
  display: flex;
  .pic {
    width: 32px;
    height: 32px;
    border-radius: 32px;
    margin-right: 10px;
    background-color: #f2f2f2;
    display: inline-block;
  }
  .tel {
    color: #fff;
  }
}
.search-bar input {
  min-width: 315px;
  height: 100%;
  padding-left: 10px;
  font-size: 14px;
  color: @wordColor1;
  border-radius: 3px;
}

.search-icon {
  width: 16px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 5px;
  margin-bottom: 4px;
}

.search-icon img {
  display: block;
  width: 100%;
}

.search-bar-body {
  width: 100%;
  position: relative;
  display: flex;
}

input::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #879bba;
}
input::-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #879bba;
}

.search-line {
  width: 100%;
  position: relative;
  display: flex;
  border: 1px solid rgba(204, 204, 204, 1);
  box-sizing: border-box;
  border-right: none;
  input {
    border: none;
    padding-left: 10px;
    width: 330px;
    font-size: 14px;
  }
}

.search-bar .search-button {
  min-width: 44px;
  height: 34px;
  background: rgba(27, 156, 255, 1);
  border-radius: 0px 3px 3px 0px;
  text-align: center;
  line-height: 34px;
  border: none;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}

.law-search .search-button {
  min-width: 44px;
  height: 34px;
  background: @mainColor;
  border-radius: 0px 3px 3px 0px;
  text-align: center;
  line-height: 34px;
  border: none;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}
.search-bar .search-button:hover {
  background: @mainColor;
}

.search-panel {
  position: absolute;
  top: 40px;
  width: 420px;
  height: 360px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 8px 0px rgba(27, 69, 137, 0.3);
  border-radius: 4px;
  border: 1px solid @lineColor;
  z-index: 99;
  overflow-y: auto;
}

.search-panel .hit-item {
  margin: 15px 0;
  cursor: pointer;
}

.search-panel .is-loading {
  text-align: center;
  margin-top: 40%;
}

.hit-item .title {
  color: @wordColor2;
  margin-left: 15px;
  margin-right: 15px;
  margin-bottom: 5px;
}

.hit-item p {
  color: @wordColor1;
  line-height: 30px;
  padding: 0 15px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.hit-item p:hover {
  background: #ecf5ff;
}

.search-bar .search-select {
  width: 108px;
}

.back-to-top {
  position: fixed;
  right: 0;
  bottom: 80px;
  width: 40px;
  height: 40px;
  background: rgba(34, 34, 34, 1);
  border-radius: 4px 0 0 4px;
  z-index: 1001;
  cursor: pointer;
  color: #fff;
  text-align: center;
  transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  -webkit-transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  -o-transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  -moz-transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  i {
    margin-top: 10px;
  }
  p {
    display: none;
    margin: 8px 5px;
  }
}

.back-to-top:hover {
  background: #e42626;
  i {
    display: none;
  }
  p {
    display: block;
  }
  &::before {
    display: block;
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    top: -13px;
    left: 50%;
    transform: translateX(-50%);
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-bottom: 8px solid #e42626;
  }
}
.search-high-box {
  display: flex;
  position: absolute;
  border-radius: 3px;
  z-index: 100;
  height: 36px;
  line-height: 36px;
  left: 50%;
  top: 12px;
  margin-left: 275px;
  align-items: center;
  justify-content: center;
  color: #222;
  font-size: 16px;
  background: #fff;
  .search-high-box-indiv {
    margin-left: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    &.pagejump-checkbox {
      span {
        padding: 0 30px;
        display: inline-block;
        margin-left: 0;
        background: #E42626;
        border-radius: 3px;
        font-size: 14px;
        height: 35px;
        // line-height: 35px;
        color: #fff;
      }
    }
    .el-checkbox {
      color: #222 !important;
    }
    /deep/ .el-checkbox__label {
      font-size: 16px;
    }
    span {
      margin-left: 5px;
    }
  }
  
}
.search-body-box {
  width: 550px;
  display: flex;
  position: absolute;
  border-radius: 3px;
  z-index: 99;
  height: 36px;
  line-height: 36px;
  background: #fff;
  left: 50%;
  // transform: translateX(-50%);
  top: 12px;
  margin-left: -276px;
  border: 1px solid #E6E6E6;
  font-size: 16px;
  box-sizing: border-box;
  .search-select {
    flex: 0 0 100px;
    border-right: 1px solid #E6E6E6;
    /deep/ .el-input__inner {
      font-size: 16px;
      border: none;
      height: 34px;
      line-height: 33px;
      border-radius: 4px;
      display: block;
    }
    .el-select {
      line-height: 36px;
      display: block;
    }
  }
  .search-input {
    margin-left: 10px;
    position: relative;
    flex: 1;
    .search-input-close {
      display: inline-block;
      color: #666;
      cursor: pointer;
    }
    .icon-middle {
      margin-bottom: 2px;
    }
    input {
      height: 31px;
      color: #212731;
      width: 90%;
      vertical-align: baseline;
      &::-webkit-input-placeholder { /* WebKit browsers */ 
        font-size: 14px;
      } 
      &:-moz-placeholder { /* Mozilla Firefox 4 to 18 */ 
        font-size: 14px;
      } 
      &::-moz-placeholder { /* Mozilla Firefox 19+ */ 
        font-size: 14px;
      } 
      &:-ms-input-placeholder { /* Internet Explorer 10+ */ 
        font-size: 14px;
      }
    }
    .search-history, 
    .search-preview {
      min-height: auto;
      max-height: 350px;
      overflow-y: auto;
      width: 450px;
      left: -10px;
      top: 50px;
      position: absolute;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 6px 11px 1px rgba(0, 0, 0, 0.06);
      border-radius: 4px;
      border: 1px solid rgba(230, 230, 230, 1);
      box-sizing: border-box;
      .preview-item {
        height: 40px;
        line-height: 40px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        padding: 0 20px;
      }
      .preview-item:hover {
        background: #f0f0f0;
        cursor: pointer;
      }
      .search-history-item {
        padding: 10px 20px;
        font-size: 14px;
        color: #666;
        line-height: 20px;
        height: 20px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        border-bottom: 1px solid #E6E6E6;
        &:hover {
          background: #f0f0f0;
          cursor: pointer;
        }
      }
    }
    .search-history {
      max-height: 245px;
      overflow-y: hidden;
      font-size: 14px;
      min-height: auto;
      .search-history-wrap {
        min-height: auto;
        max-height: 205px;
        overflow-y: auto;
        &::-webkit-scrollbar {
          width: 8px;
        }
        &::-webkit-scrollbar-track {
          border-radius:10px;
        }
        &::-webkit-scrollbar-thumb {
          border-radius:10px;
          background:rgba(0,0,0,0.1);
        }
        &::-webkit-scrollbar-thumb:window-inactive {
          background:rgba(0,0,0,0.4);
        }
      }
      .search-history-del {
        height: 40px;
        width: 100%;
        background: #fff;
        padding: 0 20px;
        box-sizing: border-box;
        .search-history-del-fr {
          float: right;
          font-size: 12px;
          color: #666;
          height: 40px;
          line-height: 40px;
          cursor: pointer;
        }
      }
    }
  }
  .search-btn {
      margin: 0;
      padding: 0 14px;
      height: 35px;
      background: #E42626;
      text-align: center;
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;
      cursor: pointer;
      color: #fff;
      font-size: 14px;
    }
}
.course-filter {
  width: 1200px;
  box-sizing: border-box;
  background: #fff;
  border:1px solid #e6e6e6;
  border-top: 3px solid #e42626;
  position: absolute;
  top: 70px;
  left: 50%;
  margin-left: -600px;
  box-shadow: 0 6px 11px rgba(0,0,0,0.1);
  .course-filter-head {
    height: 40px;
    line-height: 40px;
    color: #222;
    font-size: 18px;
    padding: 0 30px;
    border-bottom: 1px solid #E6E6E6;
    .course-filter-head-fr {
      float: right;
      cursor: pointer;
    }
    .course-filter-head-name {
      
    }
  }
}
</style>
<style lang="less">
.search-bar .el-input__inner {
  height: 34px;
  line-height: 34px;
  border: none;
}
.search-bar .el-input__icon {
  line-height: 34px;
}

.search-line .el-input {
  height: 32px;
  line-height: 32px;
  overflow: hidden;
}

.search-line .el-input__inner {
  border: none;
  height: 32px;
  line-height: 32px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.search-line .el-select__caret {
  line-height: 34px;
}

.law-search-select .el-select-dropdown__wrap {
  min-height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/views/law/Layout.vue